export interface RequestAWSAccountSubnetModel {
	name: string;
	aZ1_CIDR: string;
	aZ2_CIDR?: string;
	aZ3_CIDR?: string;
	uniqueRouteTablePerAz: boolean;
}

export class RequestAWSAccountVPCModel {

	id!: number; 

	region!: string;

	priority!: number;

	cidr!: string;

	route53ResolverRuleAssociations!: string;

	enableS3GatewayEndpoint!: boolean;

	tags!: { [key: string]: string };

	subnets!: RequestAWSAccountSubnetModel[];

	constructor(obj: any) {
		this.region = obj.region;
		this.priority = obj.priority;
		this.cidr = obj.cidr;
		this.route53ResolverRuleAssociations = obj.route53ResolverRuleAssociations || '';
		this.enableS3GatewayEndpoint = obj.enableS3GatewayEndpoint ?? false;
		this.tags = obj.tags || {};
		
		if (obj.subnets && Array.isArray(obj.subnets)) {
			this.subnets = obj.subnets.map((subnet: any) => ({
				name: subnet.name,
				aZ1_CIDR: subnet.aZ1_CIDR,
				aZ2_CIDR: subnet.aZ2_CIDR || undefined,
				aZ3_CIDR: subnet.aZ3_CIDR || undefined,
				uniqueRouteTablePerAz: subnet.uniqueRouteTablePerAz ?? false,
			}));
		} else {
			this.subnets = [];
		}
	}
}
